import { Button, ErrorState, LoadingState, Widget } from '@cinesend/ui-kit'
import { DotsSixVertical, X } from '@phosphor-icons/react'

const DashboardWidget = ({
  id,
  title,
  editing,
  isDragging,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  onRemove,
  isLoading,
  error,
  onRetry,
  children,
}) => {
  return (
    <div
      className={`${editing ? 'cursor-grab active:cursor-grabbing' : ''} ${isDragging ? 'opacity-60' : ''}`}
      draggable={editing}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      aria-grabbed={editing ? isDragging : undefined}
      data-widget-id={id}
    >
      <Widget
        title={title}
        headingAction={
          editing ? (
            <DotsSixVertical
              size={20}
              weight='regular'
              aria-hidden='true'
              className='text-[color:var(--cs-color-foreground-secondary)]'
            />
          ) : null
        }
        trailingAction={
          editing ? (
            <Button
              variant='ghost'
              iconOnly
              tooltip='Remove widget'
              data-widget-remove
              leadingIcon={<X size={20} weight='regular' aria-hidden='true' />}
              onMouseDown={(event) => event.stopPropagation()}
              onClick={(event) => {
                event.stopPropagation()
                onRemove(id)
              }}
            >
              Remove widget
            </Button>
          ) : null
        }
      >
        <div className={`flex min-h-0 flex-1 flex-col ${editing ? 'pointer-events-none' : ''}`}>
          {error ? (
            <ErrorState
              message={error.message ?? 'An error occurred. Please contact customer support.'}
              onRetry={onRetry}
            />
          ) : isLoading ? (
            <LoadingState className='justify-center' />
          ) : (
            children
          )}
        </div>
      </Widget>
    </div>
  )
}

export default DashboardWidget
